import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import DatePicker from "../Common/DatePicker";
import CustomButton from "../Common/CustomButton";
import CloseIcon from "../Common/CloseIcon";

import { formatDate, nowWithOutSeconds } from "../../utils/date";

import images from "../../assets/img/images";

const styles = {
  filter: {
    height: "34px",
    width: "100%",
    border: "1px solid #c4c4c4",
    borderRadius: "2px",
    cursor: "pointer",
    fontWeight: "400",
  },
  calendarIcon: {
    margin: "4px 8px 4px 4px",
  },
  all: {
    lineHeight: "1.5",
    verticalAlign: "middle",
    fontSize: "1.1em",
  },
  rangeDate: {
    lineHeight: "1.3",
    fontSize: "0.7em",
  },
  applyBtn: {
    marginTop: 0,
    marginBottom: 0,
  },
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px 24px",
  },
};

const DateFilter = (props) => {
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(props.startDate);
  const [endDate, setEndDate] = useState(props.endDate);

  useEffect(() => {
    if (startDate !== props.startDate) {
      setStartDate(props.startDate);
    }
    if (endDate !== props.endDate) {
      setEndDate(props.endDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.startDate, props.endDate]);

  const handleFilter = () => {
    setOpen(false);
    props.returnData(props.filter, props.parent, startDate, endDate);
  };

  const handleChange = (name, date) => {
    date = new Date(date);
    date = date.getTime();
    if (name === "startDate") {
      setStartDate(date);
    } else if (name === "endDate") {
      setEndDate(date);
    }
  };

  const handleReset = () => {
    setOpen(false);
    setStartDate(nowWithOutSeconds());
    setEndDate(nowWithOutSeconds());
    props.returnData(props.filter, props.parent, null, null);
  };

  return (
    <div>
      <Box className={props.classes.filter} onClick={() => setOpen(true)}>
        <Grid container className="height-100">
          <Grid item className="flexCenter">
            <img
              src={images.calendarIcon}
              alt="calendar"
              className={props.classes.calendarIcon}
            />
          </Grid>
          <Grid item className="flexCenter" style={{ maxWidth: "87px" }}>
            {startDate !== endDate ? (
              <Grid container direction="column">
                <Grid item className={props.classes.rangeDate}>
                  {formatDate(startDate, "MM/DD/YYYY hh:mm")}
                </Grid>
                <Grid item className={props.classes.rangeDate}>
                  {formatDate(endDate, "MM/DD/YYYY hh:mm")}
                </Grid>
              </Grid>
            ) : (
              <span className={props.classes.all}>-</span>
            )}
          </Grid>
        </Grid>
      </Box>
      <Dialog open={open} aria-labelledby="form-dialog-title">
        <Grid container wrap="nowrap">
          <Grid item xs={10}>
            <DialogTitle className={props.classes.title}>
              {I18n.get("site_filterDate")}
            </DialogTitle>
          </Grid>
          <Grid item xs={2} className={props.classes.closeBtn}>
            <CloseIcon closeFunction={() => setOpen(false)} />
          </Grid>
        </Grid>
        <DialogContent>
          <DialogContentText>
            {I18n.get("site_filterDateText")}
          </DialogContentText>
          <DatePicker
            label={I18n.get("site_startDate")}
            name="startDate"
            value={startDate}
            onChange={handleChange}
            width="250px"
          />
          <DatePicker
            label={I18n.get("site_endDate")}
            name="endDate"
            value={endDate}
            onChange={handleChange}
            width="250px"
          />
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "24px 0px",
          }}
        >
          <CustomButton onClick={() => setOpen(false)} color="primary">
            {I18n.get("site_cancel")}
          </CustomButton>
          <CustomButton onClick={handleReset} color="primary">
            {I18n.get("site_reset")}
          </CustomButton>
          <CustomButton
            onClick={handleFilter}
            variant="contained"
            color="primary"
            className={props.classes.applyBtn}
          >
            {I18n.get("site_apply")}
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(DateFilter);
